import type { ActionTree } from 'vuex'
import type { SystemState } from './typing'
import type { RootState } from '@/store/root-state'

export const actions: ActionTree<SystemState, RootState> = {}
